import { CodeIcon, EyeIcon, LawIcon, LinkExternalIcon, RepoForkedIcon, StarFillIcon } from '@primer/octicons-react';
import PropTypes from 'prop-types';
import React from 'react';
import { AnchorLink, TextItem } from '@/styles/commonStyles';
import colors from '@/styles/colors';
import { CardFooter, FooterButton, FooterContent, FooterContentItem, FooterCountBox, FooterIconBox } from '../styles';

export default function RenderCardFooter({ footerData, type }) {
  const { url, licenseInfo, stargazerCount, forkCount, watchers, homepageUrl } = footerData || {};
  return (
    <CardFooter>
      <FooterContent>
        <FooterContentItem>
          <FooterIconBox>
            <StarFillIcon fill={colors.light} />
            <TextItem className="">Star</TextItem>
          </FooterIconBox>
          <FooterCountBox className="">{stargazerCount}</FooterCountBox>
        </FooterContentItem>
        <FooterContentItem>
          <FooterIconBox>
            <EyeIcon fill={colors.light} />
            <TextItem>Watchers</TextItem>
          </FooterIconBox>
          <FooterCountBox>{watchers.totalCount}</FooterCountBox>
        </FooterContentItem>
        <FooterContentItem>
          <FooterIconBox>
            <RepoForkedIcon fill={colors.light} />
            <TextItem>Fork</TextItem>
          </FooterIconBox>
          <FooterCountBox>{forkCount}</FooterCountBox>
        </FooterContentItem>
        {licenseInfo && type === 'details' ? (
          <FooterContentItem className="border rounded-md px-1">
            <LawIcon fill={colors.light} />
            <AnchorLink href={licenseInfo?.url} className="px-1">
              {licenseInfo?.name}
            </AnchorLink>
          </FooterContentItem>
        ) : null}
      </FooterContent>
      <FooterContent>
        <FooterButton variant="outlined" href={url} endIcon={<CodeIcon />}>
          SOURCE CODE
        </FooterButton>
        <FooterButton variant="outlined" href={homepageUrl} endIcon={<LinkExternalIcon />}>
          LIVE DEMO
        </FooterButton>
      </FooterContent>
    </CardFooter>
  );
}

RenderCardFooter.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  type: PropTypes.string.isRequired,
};
